import React, { useEffect } from "react";
import "./style.scss";
import { getCoursesBlockQuiz } from "../../../service/courses";
type Props = {};

const MaintenancePage = (props: Props) => {
  useEffect(() => {
    const getCourses = async () => {
      const payload = {};
      try {
        const res = await getCoursesBlockQuiz(payload);
      } catch (err) {
        console.error(err);
        return [];
      }
    };
    getCourses();
  }, []);
  return (
    <div className="maintenance-page">
      <div className="maintenance-left">
        <div className="logo-header">
          <img
            className="logo-icon"
            loading="eager"
            alt=""
            src={`${process.env.PUBLIC_URL}/assets/img/app-logo.png`}
          />
          <div className="logo-title">
            {process.env.REACT_APP_PROJECT_NAME || ""} <br />
            <span className="font-size-14"></span>
          </div>
        </div>
        <div className="description">
          <div className="text-title-36">Xin lỗi quý khách!</div>
          <div className="text-description-16">
            Hệ thống đang trong giai đoạn bảo trì. Quý khách vui lòng truy cập
            lại sau
          </div>
          <div className="dot-loading">
            <div className="dot-flashing "></div>
          </div>
        </div>
      </div>
      <div className="maintenance-right">
        <img
          className="description-img"
          src={`${process.env.PUBLIC_URL}/assets/img/maintenance-img.png`}
          alt=""
        />
      </div>
    </div>
  );
};

export default MaintenancePage;
